export const MAX_COMPETITORS_QUANTITY = 8;

// TODO: get rid of this
export const DATE_FORMAT = 'YYYY-MM-DD';
